import BookingCalendar from '../../Calendar';
import { createRoot } from 'react-dom/client';

document.addEventListener('DOMContentLoaded', () => {
    // Use MutationObserver to watch for dynamically added .ndb-booking-calendar elements
    const processCalendars = () => {
        document.querySelectorAll('.ndb-booking-calendar').forEach((el) => {
            if (!el.dataset.processed) {
                el.dataset.processed = "true";
                // All calendars are the same, no need to track IDs
                // Initialize or process the calendar here if needed

                // Clear el style
                el.style = '';

                // Render the Calendar component into the element
                const root = createRoot(el);
                root.render(<BookingCalendar />);
            }
        });
    };

    processCalendars();

    const observer = new MutationObserver(() => {
        processCalendars();
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
